(function(){
  "use strict";

  /* Mirrors the copy used by the shopmode-tracker section + home-freegift's
     "fixed" gift variants. Kept in one place so About's contextual note and
     Help's FAQ filter label always agree on what each mode is called. */
  var MODES = {
    "motherhood-os": {
      aboutNote: "Browsing The Motherhood OS: planners, luxury binders, and modular inserts built to run your home.",
      faqLabel: "The Motherhood OS"
    },
    "books": {
      aboutNote: "Browsing Books & Guides: devotionals, activity books, and identity journals for every season.",
      faqLabel: "Books & Guides"
    },
    "printables": {
      aboutNote: "Browsing Printables & Templates: fillable PDFs you print at home and reuse all season long.",
      faqLabel: "Printables & Templates"
    },
    "heirlooms": {
      aboutNote: "Browsing Heirloom Keepsakes: engraved binders, hardcover journals, and guest books made to order.",
      faqLabel: "Heirloom Keepsakes"
    }
  };

  function activeMode(){
    try{ return sessionStorage.getItem("okimami_shopmode") || null; }catch(e){ return null; }
  }

  /* About page: shows a small "Now: ..." pill reflecting whichever shop mode
     was last visited. The founder-story content itself stays universal on
     every mode — only this one line changes. */
  function applyAboutNote(){
    var note = document.getElementById("aboutModeNote");
    if(!note) return;
    var cfg = MODES[activeMode()];
    if(!cfg){ note.hidden = true; return; }
    note.hidden = false;
    var text = note.querySelector(".mode-note-text");
    if(text) text.textContent = cfg.aboutNote;
  }

  /* Help page: FAQ items carrying data-modes="..." only show when the active
     mode is in that list; untagged items are universal and always show. */
  function applyFaqFilter(){
    var items = document.querySelectorAll(".faq-item[data-modes]");
    if(!items.length) return;
    var note = document.getElementById("faqFilterNote");
    var cfg = MODES[activeMode()];
    if(!cfg){
      for(var i = 0; i < items.length; i++){ items[i].hidden = false; }
      if(note) note.hidden = true;
      return;
    }
    var anyHidden = false;
    for(var j = 0; j < items.length; j++){
      var el = items[j];
      var modes = (el.getAttribute("data-modes") || "").split(/\s+/).filter(Boolean);
      var match = modes.indexOf(activeMode()) !== -1;
      el.hidden = !match;
      if(!match) anyHidden = true;
    }
    if(note){
      note.hidden = !anyHidden;
      var label = note.querySelector(".faq-filter-label");
      if(label) label.textContent = cfg.faqLabel;
    }
  }

  function clearMode(){
    try{ sessionStorage.removeItem("okimami_shopmode"); }catch(e){}
    applyAboutNote();
    applyFaqFilter();
  }

  document.addEventListener("DOMContentLoaded", function(){
    applyAboutNote();
    applyFaqFilter();
    var showAllBtn = document.getElementById("faqShowAll");
    if(showAllBtn){ showAllBtn.addEventListener("click", clearMode); }
  });
})();
